import { FC, PropsWithChildren, useEffect, useState } from "react"
import { getCurrentUser } from "@aws-amplify/auth"
import { Authenticator } from "@aws-amplify/ui-react"
import { Amplify } from "aws-amplify"

import { config } from "../config/app"

import "@aws-amplify/ui-react/styles.css"

// Configure Amplify with our app config
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: config.amplify.Auth.userPoolWebClientId,
      userPoolId: config.amplify.Auth.userPoolId,
    },
  },
})

export const AuthWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    void checkAuthState()
  }, [])

  async function checkAuthState() {
    try {
      await getCurrentUser()
    } catch {
      // User is not authenticated, Authenticator will handle this
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    )
  }

  return <Authenticator>{children}</Authenticator>
}
